<template>
    <div class="container-fluid reports-tab-nav employee-table-wrapper">
        <!-- Header -->
        <div class="clearfix row py-2 mb-2 no-margin">
            <div class="col-sm-6 text-left pl-0">
                <h5 class="mb-0">External Managers</h5>
            </div>
            <div class="col-sm-6 text-right pr-0">
                <b-button v-if="ce" @click="addNew">+ Add New</b-button>
            </div>
        </div>

        <!-- Table -->
        <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table dataTable border">
                        <thead>
                            <tr class="table-head">
                                <td>Employee</td>
                                <td>Email</td>
                                <td>Job Position</td>
                                <td class="text-right" v-if="ce">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(manager, index) in line_managers" :key="index">
                                <td>
                                    {{ manager.name }}<br />
                                </td>
                                <td>{{ manager.email }}</td>
                                <td>{{ manager.jobposition }}</td>
                                <td class="position-relative text-right" v-if="ce">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu w-200 px-1"
                                        aria-labelledby="actionDropdown">
                                        <b-button-group class="mr-0">
                                            <b-button class="mr-3 rounded edit-btn text-left" title="Edit"
                                                @click="showEditModal(manager.employee_id)">
                                                <b-icon icon="pencil" class="mr-2" aria-hidden="true"></b-icon>Edit
                                            </b-button>

                                            <b-button class="mr-3 rounded edit-btn text-left" title="Delete"
                                                @click="showDeleteModal(manager.employee_id)">
                                                <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="line_managers.length === 0" class="list-no-data">No records found.</div>
                </b-overlay>
            </div>
        </div>

        <b-modal id="bv-modal-add-line-manager" size="xl" scrollable hide-footer title="Add External Manager">
            <template>
                <div class="trz_leave_settings">
                    <b-overlay :show="showoverlay_list" rounded="sm" class="col-md-12">
                        <div class="row">
                            <div class="col-12">
                                <div class='mt-2'>
                                    <div class="clearfix">
                                        <b-form @submit.stop.prevent="saveLineManager" class="w-100">
                                            <div class="clearfix">
                                                <div>
                                                    <div class="col-md-6 float-left">
                                                        <b-form-group id="name-group" label="Full Name" class="required-field" label-for="name">
                                                            <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 , regex: /^[a-zA-Z.\-\s]+$/ }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                                        </b-form-group>

                                                        <b-form-group id="jobposition_id-group" label="Job Position" class="w-100 required-field" label-for="jobposition_id">
                                                            <b-form-select id="jobposition_id" name="jobposition_id" v-model="fdata.jobposition_id" :options="jobpositionOptions" :selected="jobpositionOptions.find(option => option.value == fdata.jobposition_id)"  v-validate="{ required:true, excluded: [0] }" :state="validateState('jobposition_id')" aria-describedby="jobposition_id-feedback" data-vv-as="Job Position" class="w-100"></b-form-select>
                                                            <b-form-invalid-feedback id="jobposition_id-feedback">{{ veeErrors.first('jobposition_id') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6 float-right">
                                                        <b-form-group id="email-group" label="Email Address" class="required-field" label-for="email">
                                                            <b-form-input id="email" name="email" type="email" v-model="fdata.email" v-validate="{ email: true, required:true, min:8, }" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                                            <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-md-12 float-right text-center">
                                                        <!-- alpha fix - make the btn submit  -->
                                                        <b-button type="submit" variant="primary">Submit</b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </template>
        </b-modal>

        <b-modal id="bv-modal-edit-line-manager" size="xl" scrollable hide-footer title="Edit External Manager">
            <template>
                <div class="trz_leave_settings">
                    <b-overlay :show="showoverlay_list" rounded="sm" class="col-md-12">
                        <div class="row">
                            <div class="col-12">
                                <div class='mt-2'>
                                    <div class="clearfix">
                                        <b-form @submit.stop.prevent="updateLineManager" class="w-100">
                                            <div class="clearfix">
                                                <div>
                                                    <div class="col-md-6 float-left">
                                                        <b-form-group id="name-group" label="Full Name" class="required-field" label-for="name">
                                                            <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 , regex: /^[a-zA-Z.\-\s]+$/ }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                                        </b-form-group>

                                                        <b-form-group id="jobposition_id-group" label="Job Position" class="w-100 required-field" label-for="jobposition_id">
                                                            <b-form-select id="jobposition_id" name="jobposition_id" v-model="fdata.jobposition_id" :options="jobpositionOptions" :selected="jobpositionOptions.find(option => option.value == fdata.jobposition_id)"  v-validate="{ required:true }" :state="validateState('jobposition_id')" aria-describedby="jobposition_id-feedback" data-vv-as="Job Position" class="w-100"></b-form-select>
                                                            <b-form-invalid-feedback id="jobposition_id-feedback">{{ veeErrors.first('jobposition_id') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6 float-right">
                                                        <b-form-group id="email-group" label="Email Address" class="required-field" label-for="email">
                                                            <b-form-input id="email" name="email" type="email" v-model="fdata.email" v-validate="{ email: true, required:true, min:8, }" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                                            <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12 float-right text-center">
                                                        <b-button type="submit" variant="primary">Update</b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </template>
        </b-modal>

        <!-- <b-modal id="bv-modal-delete-line-manager" size="sm" scrollable hide-footer title="Delete Confirmation">
            <div class="clearfix">
                <div class="py-3">
                    <p>Are you sure you want to delete this Line Manager?</p>
                    <div class="btn-wrapper text-center mt-5">
                        <b-button type="button" variant="danger" @click="deleteLineManager">Delete</b-button>
                    </div>
                </div>
            </div>
        </b-modal> -->

    </div>
</template>

<script>
export default {
    data() {
        return {
            line_managers: [],
            showoverlay_list: false,
            ce: true,
            employee_id: 0,
            fdata: {
                name: '',
                email: '',
                jobposition_id: null,
            },
            jobposition: [],
        };
    },
    created: function () {
        this.getLineManagers();
    },
    computed: {
        jobpositionOptions() {
            return this.jobposition.map(item => ({
                value: item.id,
                text: item.name || item.text,
            }));
        }
    },
    methods: {
        getLineManagers() {
            this.$bvModal.hide('bv-modal-add-line-manager');
            this.$bvModal.hide('bv-modal-edit-line-manager');
            // Abdullah26 commented this
            // this.$bvModal.hide('bv-modal-delete-line-manager');

            this.showoverlay_list = true;
            axios
                .get(this.$api_url + '/line-manager/get-list')
                .then((response) => {
                    this.line_managers = response.data.data;
                    this.showoverlay_list = false;
                })
                .catch((err) => {
                    console.error('Error fetching line managers:', err);
                    this.line_managers = [];
                    this.showoverlay_list = false;
                });
        },
        addNew() {
            this.fdata = {
                name: '',
                email: '',
                jobposition_id: 0,
            };
            this.getJobPositions();
            this.$bvModal.show('bv-modal-add-line-manager');
        },
        saveLineManager() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.showoverlay_list = true;

                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdata)) {
                    formData.append(key, value);
                }

                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' }
                };

                axios.post(this.$api_url + '/line-manager/save', formData, config)
                    .then(response => {
                        this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                            title: response.data.toast_title || 'Success',
                            variant: response.data.toast_variant || 'success',
                            solid: true
                        });

                        if (response.data.status != 200) {
                            return;
                        }

                        this.getLineManagers();
                    })
                    .catch(error => {
                        const message =
                            error.response && error.response.data && error.response.data.message
                                ? error.response.data.message
                                : 'An unexpected error occurred.';

                        this.$bvToast.toast(message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    })
                    .finally(() => {
                        this.showoverlay_list = false;
                    });
            });
        },
        showEditModal(employee_id) {
            this.employee_id = employee_id;
            this.getJobPositions();
            this.getLineManager();
            this.$bvModal.show('bv-modal-edit-line-manager');
        },
        getLineManager() {
            this.showoverlay_list = true;
            axios.post(this.$api_url + '/line-manager/get-info', {
                employee_id: this.employee_id
            })
                .then(response => {
                    this.fdata = {
                        employee_id: this.employee_id,
                        name: response.data.data.name,
                        phone: response.data.data.phone,
                        email: response.data.data.email,
                        jobposition_id: response.data.data.jobposition_id
                    };
                })
                .finally(() => {
                    this.showoverlay_list = false;
                });
        },
        updateLineManager() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.showoverlay_list = true;

                axios.post(this.$api_url + '/line-manager/update', this.fdata)
                    .then(response => {
                        this.$bvToast.toast(response.data.message || 'Updated successfully.', {
                            title: response.data.toast_title || 'Success',
                            variant: response.data.toast_variant || 'success',
                            solid: true
                        });

                        if (response.data.status != 200) {
                            return;
                        }

                        this.getLineManagers();
                    })
                    .catch(error => {
                        const message =
                            error.response && error.response.data && error.response.data.message
                                ? error.response.data.message
                                : 'An unexpected error occurred.';

                        this.$bvToast.toast(message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    })
                    .finally(() => {
                        this.showoverlay_list = false;
                    });
            });
        },

        // Abdullah26 commented this
        // showDeleteModal(employee_id) {
        //     this.employee_id = employee_id;
        //     this.$bvModal.show('bv-modal-delete-line-manager');
        // },
        // deleteLineManager() {
        //     this.showoverlay_list = true;
        //     axios
        //         .post(this.$api_url + '/line-manager/delete', {
        //             employee_id: this.employee_id,
        //         })
        //         .then((response) => {
        //             this.showoverlay_list = false;
        //             this.$bvToast.toast('Deleted!', {
        //                 title: `Success`,
        //                 variant: 'success',
        //                 solid: true,
        //             });
        //             this.getLineManagers();
        //             this.$bvModal.hide('bv-modal-delete-line-manager');
        //         })
        //         .catch((err) => {
        //             this.showoverlay_list = false;
        //             this.$bvToast.toast(err.response.data.message, {
        //                 title: `Error!`,
        //                 variant: 'danger',
        //                 solid: true,
        //             });
        //         });
        // },

        // Abdullah26 added this
        showDeleteModal(employee_id) {
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this Line Manager?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    this.showoverlay_list = true;
                    axios.post(this.$api_url + '/line-manager/delete', {
                        employee_id: employee_id
                    })
                        .then((response) => {
                            this.showoverlay_list = false;
                            this.$bvToast.toast('Deleted!', {
                                title: 'Success',
                                variant: 'success',
                                solid: true,
                            });
                            this.getLineManagers();
                        })
                        .catch((err) => {
                            this.showoverlay_list = false;
                            this.$bvToast.toast(err.response.data.message, {
                                title: 'Error!',
                                variant: 'danger',
                                solid: true,
                            });
                        });
                }
            });
        },
        // getJobPositions: function () {
        //     axios.get(this.$api_url + '/line-manager/get-reporting-manager-positions').then(function (response) {
        //         this.jobposition = [{ value: 0, text: "Select..." }].concat(response.data);
        //     }.bind(this));
        // },

        getJobPositions: function () {
            axios.get(this.$api_url + '/line-manager/get-reporting-manager-positions').then(function (response) {
                this.jobposition = [{ id: 0, name: "Select..." }].concat(response.data);
            }.bind(this));
        },
        getJobPositionTitle(id) {
            const position = this.jobposition.find(item => item.id === id);
            return position ? (position.name || position.text) : '';
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        }
    },
};
</script>

<style scoped>
.img-holder {
    cursor: not-allowed;
    pointer-events: none;
}

.employee-avatar {
    width: 40px;
    height: 40px;
}

.table-head {
    font-weight: bold;
}

/* Abdullah26 added this css  */
select.custom-select {
    width: 100% !important;
}
</style>
